import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translations
import translationEN from "./locales/en/translation.json";
import translationFR from "./locales/fr/translation.json";
import translationHI from "./locales/hi/translation.json";
import translationDutch from "./locales/dutch/translation.json";
import translationBangla from "./locales/bangla/translation.json";
import translationTamil from "./locales/tamil/translation.json";
import translationAR from "./locales/arabic/translation.json";

// Define translations
const resources = {
  en: { translation: translationEN },
  fr: { translation: translationFR },
  hi: { translation: translationHI },
  dutch: { translation: translationDutch },
  bangla: { translation: translationBangla },
  tamil: { translation: translationTamil },
  ar: { translation: translationAR },
};

const hostname = window.location.hostname.toLowerCase();


let initialLang = "en";


switch (true) {
  case hostname.includes("bangladeshicc"):
    initialLang = "bangla";
    break;
  case hostname.includes("srilankaicc"):
    initialLang = "tamil";
    break;
  case hostname.includes("englandicc"):
    initialLang = "en";
    break; 
  default:
    initialLang = "en";
    break;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLang, 
    fallbackLng: "en",
    supportedLngs: ["en", "fr", "hi", "dutch", "bangla", "tamil", "ar"],
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
